// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"
import "./version_poller"
import "./pwa_install"
import "./push_notifications"
import "./analytics"
import "./update_notifier"

// ── Turbo Flicker Prevention ──────────────────────────────────────────
// After the first Turbo visit completes, mark <html> so CSS knows
// not to replay page-entry animations on subsequent navigations.
document.addEventListener("turbo:load", () => {
  document.documentElement.classList.add("turbo-loaded")
})
